<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <input
        :type="type"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :placeholder="placeholder"
        class="input input-bordered w-full text-sm"
    />
</template>

<script>
export default {
    name: 'InputComponent',
    props: ['modelValue', 'type', 'placeholder']
};
</script>

<style scoped></style>
